import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// common
import { updateReportFromReportListSuccess } from '../../common/actions';
// report-common
import { getReportReducers } from '../../report-common';
// feature user
import * as A from './actions';
//////////////////////////////////////////////////

export const initial = {
  passwordConfigs: null,
  availableByTypeRoleList: null,
};

const {
  setReports,
  selectItem,
  initialState,
  setUsedReport,
  setListLoading,
  setInitialState,
  setReportPending,
  deleteItemSuccess,
  setTableTitleSort,
  getItemListSuccess,
  setTableTitleFilter,
  resetListAndPagination,
  setInitialStateOmitReport,
  handleUpdateReportFromReportListSuccess,
} = getReportReducers(initial);

const getPasswordConfigsForUsersSuccess = (state, configs) => (
  P.$set('passwordConfigs', configs, state)
);

const getAvailableByTypeRoleListSuccess = (state, data) => (
  P.$set('availableByTypeRoleList', data, state)
);

const clearUsersStateAfterSwitchBranch = () => initialState;

const setFilterProps = (state, data) => P.$set('filterProps', data, state);


export default createReducer({
  // report common
  [A.setReports]: setReports,
  [A.selectItem]: selectItem,
  [A.setUsedReport]: setUsedReport,
  [A.setListLoading]: setListLoading,
  [A.setInitialState]: setInitialState,
  [A.setReportPending]: setReportPending,
  [A.deleteItemSuccess]: deleteItemSuccess,
  [A.setTableTitleSort]: setTableTitleSort,
  [A.getItemListSuccess]: getItemListSuccess,
  [A.setTableTitleFilter]: setTableTitleFilter,
  [A.resetListAndPagination]: resetListAndPagination,
  [A.setInitialStateOmitReport]: setInitialStateOmitReport,
  [updateReportFromReportListSuccess]: handleUpdateReportFromReportListSuccess,
  // report common
  [A.setFilterProps]: setFilterProps,
  [A.clearUsersStateAfterSwitchBranch]: clearUsersStateAfterSwitchBranch,
  [A.getPasswordConfigsForUsersSuccess]: getPasswordConfigsForUsersSuccess,
  [A.getAvailableByTypeRoleListSuccess]: getAvailableByTypeRoleListSuccess,
}, initialState);
